import { Route, Routes } from "react-router-dom";
import DataModifySetting from "pages/management/setting/data/data-modify";
import DataAddSetting from "pages/management/setting/data/data-add";
import DataSetting from "pages/management/setting/data/data";
import { PERMISSIONS } from "config/permissions";
import PermissionRoute from "components/route/PermissionRoute";
import RouteAccessError from "pages/RouteAccessError";

export default function MonitoringSettingDataRoutes(props) {
    return (
        <Routes>
            <Route path="/">
                <Route
                    index
                    element={
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_DATAROOM_READ}
                        >
                            <DataSetting />
                        </PermissionRoute>
                    }
                />
                <Route path=":id" 
                    element={ 
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_DATAROOM_READ}
                        >
                            <DataModifySetting />
                        </PermissionRoute> 
                    }
                 />
                <Route path="add" 
                    element={  
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_DATAROOM_WRITE}
                        >
                            <DataAddSetting />
                        </PermissionRoute> 
                    }
                />
                <Route path="*" element={ <RouteAccessError /> }/>
            </Route>
        </Routes>
    );
}